import styled from 'styled-components'
import DefaultButton from './DefaultButton'

const ClearButton = styled(DefaultButton)`
  font-weight: bold;
  height: 50px;
  padding: 0 12px;
  width: 120px;
`

export default ClearButton
